import { Link } from "react-router-dom";
import { TOP_50_PAGES, findTopPage, type PageCategory } from "@/data/topPages";

const CATEGORY_LABELS: Record<PageCategory, string> = {
  stadt: "Städte",
  kategorie: "Nach Nutzung",
  naehe: "In der Nähe",
  rechner: "Rechner",
  ratgeber: "Ratgeber",
  gewerbegebiet: "Gewerbegebiete",
  review: "Bewertungen",
  hub: "Übersichten",
};

interface Props {
  currentPath: string;
}

export const Top50Interlinks = ({ currentPath }: Props) => {
  const current = findTopPage(currentPath);
  const preferredOrder: PageCategory[] = current
    ? [current.category, ...(["stadt", "kategorie", "ratgeber", "rechner", "naehe", "gewerbegebiet", "review", "hub"] as PageCategory[]).filter(c => c !== current.category)]
    : ["stadt", "kategorie", "ratgeber", "rechner", "naehe"];

  const grouped: Record<string, typeof TOP_50_PAGES> = {};
  for (const cat of preferredOrder) {
    grouped[cat] = TOP_50_PAGES.filter(p => p.category === cat && p.path !== currentPath).slice(0, 6);
  }

  return (
    <nav
      aria-label="Weiterführende Themen"
      className="my-10 rounded-xl border border-border bg-card p-6"
    >
      <h2 className="text-lg font-semibold text-foreground mb-4">
        Weiterführende Themen auf gewerbeflaeche-mieten.de
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {preferredOrder.slice(0, 6).map((cat) => {
          const pages = grouped[cat];
          if (!pages?.length) return null;
          return (
            <div key={cat}>
              <h3 className="text-sm font-semibold text-foreground mb-2">
                {CATEGORY_LABELS[cat]}
              </h3>
              <ul className="space-y-1.5">
                {pages.map((p) => (
                  <li key={p.path}>
                    <Link
                      to={p.path}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    >
                      {p.short}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </nav>
  );
};
